<template>
    <transition name="fade">
        <div v-if="ready && contracts" class="VirtualContractsForVehicleWidget__Component">
            <div class="VirtualContractsForVehicleWidget__Component__Item" v-for="item in contracts" :key="item.Id">
                <label>
                    שוכר:
                    <a :href="`/clients/${item.Profile.Id}`"><span>{{ item.Profile.Name }}</span></a>
                </label>
                <label>
                    ח.פ:
                    <span>{{ item.Profile.IdNumber }}</span>
                </label>
                <label v-if="item.ContractOwner">
                    חברת ליסינג:
                    <a :href="`/clients/${item.ContractOwner.Id}`"><span>{{ item.ContractOwner.Name }}</span></a>
                </label>
                <label>
                    מתאריך:
                    <FieldDateHourInline :value="item.StartDate" />
                </label>
                <label>
                    עד תאריך:
                    <FieldDateHourInline :value="item.EndDate" />
                </label>
                <label>
                    הצהרת חוכר:
                    <span>{{ item.HasTransferHtml ? 'כן' : 'לא' }}</span>
                </label>
                <label>
                    קיים טופס איסוף השכרה:
                    <span>{{ item.HasRentalPickUpFormHtml ? 'כן' : 'לא' }}</span>
                </label>
                <label>
                    קיים טופס החזרת השכרה:
                    <span>{{ item.HasRentalReturnFormHtml ? 'כן' : 'לא' }}</span>
                </label>
                <label>
                    קיים רישיון נהיגה:
                    <span>{{ item.HasDriversLicenseHtml ? 'כן' : 'לא' }}</span>
                </label>
                <router-link :to="{ name: 'VirtualContract', params: { id: item.Id }}">
                    <span class="preview">הצג</span>
                </router-link>
            </div>
            <div v-if="!contracts.length">לא קיים חוזה נקודתי</div>
        </div>
    </transition>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import VehicleService from '@/services/VehicleService';
import FieldDateHourInline from '../Fields/FieldDateHourInline.vue';

export default {
    name: 'VirtualContractsForVehicleWidget',
    props: ['ready', 'namespace', 'delegate'],
    data() {
        return {
            contracts: null,
        };
    },
    beforeCreate() {
        const { namespace } = this.$options.propsData;
        const { mapState } = createNamespacedHelpers(namespace);
        this.$options.computed = {
            ...mapState(['Id']),
        };
    },
    methods: {
        init() {
            if (this.Id) {
                const fetch = this.delegate
                    ? VehicleService.getVirtualContractsAdmin
                    : VehicleService.getVirtualContracts;
                fetch(this.Id)
                    .then((r) => {
                        this.contracts = r.data || [];
                    })
                    .finally(() => {
                        this.$emit('onReady', { titleCount: this.contracts ? this.contracts.length : 0 });
                    });
            }
        },
    },
    watch: {
        // immediate so the fetch still runs when the widget is mounted late (hidden until the parent
        // resolves whether the vehicle has any virtual contracts, by which point `ready` is already true).
        ready: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.init();
                }
            },
        },
    },
    components: {
        FieldDateHourInline,
    },
};
</script>

<style lang="scss" scoped>
.VirtualContractsForVehicleWidget__Component {
    width: 100%;

    .VirtualContractsForVehicleWidget__Component__Item {
        border: 1px solid #e4eaf1;
        background-color: #eef1f3;
        border-radius: 3px;
        margin: 10px 0;
        padding: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        font-weight: bold;

        span {
            font-weight: normal;
        }

        a {
            color: #06c;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .preview {
        position: absolute;
        left: 10px;
        top: 10px;
        color: #57B7CA;
        cursor: pointer;
        font-weight: 500 !important;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
